import { FutureWorkByActionTypes, FutureWorkByState, READ_FUTURE_WORK_BY_DATA_REQUEST, READ_FUTURE_WORK_BY_DATA_SUCCESS, READ_FUTURE_WORK_BY_DATA_FAILURE } from "store/reducers/types/dashboard/futureWorkBy";

const defaultState: FutureWorkByState = {
  isLoading: false,
  errorMessage: "",
};

export default function futureWorkBy(state = defaultState, action: FutureWorkByActionTypes): FutureWorkByState {
  switch (action.type) {
    case READ_FUTURE_WORK_BY_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_FUTURE_WORK_BY_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_FUTURE_WORK_BY_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
